import BaseChart from '../baseChart';

// type Props = {
//   /** An additional class. */
//   className: ?string,
//   /* Series Data array for chart */
//   data: [],
//   /* Set additional options for bar chart. */
//   options: {},
//   /* Theme of the bar chart. */
//   theme: string,
// };

export default function Bar(props) {
  const { className, data, options, ...otherProps } = props;

  const defaultOptions = {
    plotOptions: {
      bar: {
        pointPadding: 0.15,
        borderWidth: 0,
        edgeWidth: 0,
        groupPadding: 0,
      },
    },
  };

  return (
    <BaseChart
      className={className}
      chartType="bar"
      data={data}
      defaultOptions={defaultOptions}
      options={options}
      {...otherProps}
    />
  );
}
